import { forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { MenuSubTrigger as ArcMenuSubTrigger, MenuSubTriggerProps } from 'arc';

export const MenuSubTrigger = forwardRef(function (
    props: MenuSubTriggerProps,
    ref: React.Ref<HTMLDivElement>
) {
    return (
        <ArcMenuSubTrigger ref={ref} {...props}>
            {props.children}
        </ArcMenuSubTrigger>
    );
});
